/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ details: NonNullable<unknown> }} Pronunciation_Report_Additional_MessageInputs */

const en_pronunciation_report_additional_message = /** @type {(inputs: Pronunciation_Report_Additional_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Additional context: ${i?.details}`)
};

const es_pronunciation_report_additional_message = /** @type {(inputs: Pronunciation_Report_Additional_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Contexto adicional: ${i?.details}`)
};

/**
* | output |
* | --- |
* | "Additional context: {details}" |
*
* @param {Pronunciation_Report_Additional_MessageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pronunciation_report_additional_message = /** @type {((inputs: Pronunciation_Report_Additional_MessageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pronunciation_Report_Additional_MessageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pronunciation_report_additional_message(inputs)
	return en_pronunciation_report_additional_message(inputs)
});